import { Pipe, PipeTransform } from '@angular/core';
import { SectionColumnType } from '../../../../../models/enum/shared/section-column-type';
import { RegexUtils } from '../../../../../utils/regex-utils';

@Pipe({
  name: 'isProductTagGroupColumn',
  standalone: false
})
export class IsProductTagGroupColumnPipe implements PipeTransform {
  transform(columnType: SectionColumnType): SectionColumnType | null {
    return RegexUtils.productTagGroupRegex.test(columnType) ? columnType : null;
  }
}
